var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section cargo-advance-search query-bill-oversea-condition",
      staticStyle: { height: "auto", width: "100%", "margin-top": "5px" }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSimple,
              expression: "showSimple"
            }
          ],
          staticClass: "cargo-advance-search-header"
        },
        [
          _c("div", { staticClass: "cargo-advance-search-toggle-trigger" }, [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAdv,
                  expression: "showAdv"
                }
              ],
              staticClass: "el-icon-arrow-left",
              style: {
                transform: !_vm.isShowingMoreSearchCondition
                  ? "rotate(-90deg)"
                  : "rotate(90deg)"
              },
              on: { click: _vm.upOrDownSearchCondition }
            })
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSimple,
                  expression: "showSimple"
                }
              ],
              staticClass: "cargo-advance-search-quick"
            },
            [
              _c("div", { staticStyle: { width: "100%" } }, [
                _c(
                  "div",
                  { staticClass: "form-column" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-position": "left",
                          inline: true,
                          "label-width": "75px"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_BillNo") } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.filter.billingNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "billingNo", $$v)
                                },
                                expression: "filter.billingNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_DateType") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { "allow-create": true },
                                    model: {
                                      value: _vm.filter.dateType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "dateType", $$v)
                                      },
                                      expression: "filter.dateType"
                                    }
                                  },
                                  _vm._l(_vm.arDateOption, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  1
                                ),
                                _c("el-date-picker", {
                                  staticStyle: { width: "122px" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.filter.minDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "minDate", $$v)
                                    },
                                    expression: "filter.minDate"
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "5px",
                                      "margin-left": "5px"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Pricing.EndDate")))]
                                ),
                                _c("el-date-picker", {
                                  staticStyle: { width: "122px" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd"
                                  },
                                  model: {
                                    value: _vm.filter.maxDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filter, "maxDate", $$v)
                                    },
                                    expression: "filter.maxDate"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("CargoMsg.Cargo_BillType") }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.filter.billType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "billType", $$v)
                                  },
                                  expression: "filter.billType"
                                }
                              },
                              _vm._l(
                                _vm.ClearingConstants.BILLING_IS_AR_LIST,
                                function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: item, value: item }
                                  })
                                }
                              ),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_AccountStatementNo")
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.filter.billingGroupNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "billingGroupNo", $$v)
                                },
                                expression: "filter.billingGroupNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_SettlementAgent")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": { settlementAgent: true },
                                "default-value": _vm.filter.settlementAgent
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.filter.settlementAgent = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ]
      ),
      _vm.showAdv
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowingMoreSearchCondition,
                  expression: "isShowingMoreSearchCondition"
                }
              ],
              staticClass: "cargo-advance-search-more"
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-left": "37px" },
                  attrs: {
                    "label-width": "75px",
                    "label-position": "left",
                    inline: true
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessNo") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.filter.jobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "jobNo", $$v)
                          },
                          expression: "filter.jobNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_DestinationAgent")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { overseaAgent: true },
                          "default-value": _vm.filter.destinationAgent
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.destinationAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ChineseFirstVesselName")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Vessel,
                          "default-value": _vm.filter.vessel,
                          "tag-value": "englishName"
                        },
                        on: { parentCallBack: _vm.onVesselSelectionChange }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_VoyageNo") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { "allow-create": true },
                          model: {
                            value: _vm.filter.voyage,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "voyage", $$v)
                            },
                            expression: "filter.voyage"
                          }
                        },
                        _vm._l(_vm.voyageNos, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.voyageNo,
                              value: item.voyageNo
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-left": "37px" },
                  attrs: {
                    "label-width": "75px",
                    "label-position": "left",
                    inline: true
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BusinessCategory")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          multiple: "",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$LOBS,
                          "default-multiple-value": _vm.filter.lob
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.lob = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_SettleAccountsTo")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { active: true },
                          "default-value": _vm.filter.accountId
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.accountId = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_AmountRange") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "84px" },
                            model: {
                              value: _vm.filter.amountMin,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "amountMin", $$v)
                              },
                              expression: "filter.amountMin"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-right": "5px",
                                "margin-left": "5px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_To")))]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "84px" },
                            model: {
                              value: _vm.filter.amountMax,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "amountMax", $$v)
                              },
                              expression: "filter.amountMax"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ConsolidateOrNot")
                      }
                    },
                    [
                      _c("el-checkbox", {
                        model: {
                          value: _vm.filter.merge,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "merge", $$v)
                          },
                          expression: "filter.merge"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-left": "37px" },
                  attrs: {
                    "label-width": "75px",
                    "label-position": "left",
                    inline: true
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessStatus") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.filter.jobState,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "jobState", $$v)
                            },
                            expression: "filter.jobState"
                          }
                        },
                        _vm._l(_vm.jobStates, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCompany") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Office,
                          "callback-params": { key: "opOffice" },
                          "callback-method-type": "value"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.opOffice = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Currency") } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.filter.currency,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "currency", $$v)
                            },
                            expression: "filter.currency"
                          }
                        },
                        _vm._l(
                          _vm.ClearingConstants.CURRENCY_LIST_OPTION,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item, value: item }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_WriteOffStatus") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.filter.clearingState,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "clearingState", $$v)
                            },
                            expression: "filter.clearingState"
                          }
                        },
                        _vm._l(
                          _vm.ClearingConstants.BILL_CLEARING_STATES,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.chineseName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          ref: "searchOperations",
          staticClass: "cargo-advance-search-operations",
          staticStyle: { "margin-left": "27px" }
        },
        [_vm._t("operations")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }